<template>
  <el-dialog
    v-bind="$attrs"
    append-to-body
    v-on="$listeners"
    class="dialog-big-wrap"
    custom-class="dialog-big"
    v-loading="isLoading"
  >
    <template v-slot:title>
      <slot name="title"></slot>
    </template>
    <template v-slot:default>
      <vue-custom-scrollbar class="dialog-big__scroll-wrap">
        <div class="dialog-big__scroll-content">
          <slot name="default"></slot>
        </div>
      </vue-custom-scrollbar>
    </template>
    <template v-slot:footer>
      <slot name="footer"></slot>
    </template>
  </el-dialog>
</template>

<script>
export default {
  name: 'DialogBig',
  props: {
    isLoading: { type: Boolean, default: false }
  }
}
</script>

<style lang="stylus">
  .dialog-big{
    margin-top 3.5rem !important
    margin-bottom 3.5rem !important
    display grid
    grid-template-rows auto 1fr auto
    flex-direction column
    height calc(100vh - 7rem)
    width 100%
    max-width 1000px
    .el-dialog__header{}
    .el-dialog__body{}
    .el-dialog__footer{
      .default-form-controls{
        padding 0
      }
    }
  }
  .dialog-big__scroll-wrap{
    width 100%
    height 100%
  }
  .dialog-big__scroll-content{
    position absolute
    top 0
    left 0
    right 15px
    bottom 0
  }
</style>
